module.exports = __webpack_public_path__ + "static/pot-fishing-852e16988fe8af6f41d58b3c5b22376b.jpg";